const socialData = [
  {
    name: "LinkedIn",
    icon: "linkedin",
    url: "https://linkedin.com/in/varunraokm/"
  },
  {
    name: "GitHub",
    icon: "github",
    url: "https://github.com/varunrao1991"
  },
  {
    name: "Email",
    icon: "envelope-fill",
    url: "mailto:varunrao.rao@gmail.com"
  },
  {
    name: "YouTube",
    icon: "youtube",
    url: "https://www.youtube.com/@parallelroutines"
  }
];

export default socialData;